// COULD NOT FIND BETTER NAME SO I USED THE NAME OF THE CONTENT RATHER THAN THE FORMAT

import cx from 'classnames'
import { motion } from 'motion/react'
import { FC, useMemo } from 'react'
import { motionGroup, slideReveal } from 'src/hooks/useAppear'

import { BlockTitleProps } from '../BlockTitle'
import { PerspectiveProps } from '../Perspective'
import { SliderProps } from '../Slider'

import * as SC from './styled'

export type PerspectivePushProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  perspectives?: PerspectiveProps[]
  sliderProps?: Partial<SliderProps>
}

const PerspectivePush: FC<PerspectivePushProps> = ({
  className,
  blockTitleProps,
  perspectives = [],
  sliderProps,
}) => {
  const { motions, variants } = usePerspectivePushMotion()

  return (
    <SC.Container className={cx('PerspectivePush', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      {perspectives.length > 0 && (
        <motion.div {...motions.slider}>
          <SC._Slider
            isForDesktop
            keenOptions={{
              drag: true,
              slides: { perView: 1.2, spacing: 16 },
              defaultAnimation: { duration: 300 },
              breakpoints: {
                // 600 as in sizes
                '(min-width: 37.5em)': {
                  slides: { perView: 1.75, spacing: 16 },
                },
                // 900 as in sizes
                '(min-width: 56.25em)': {
                  slides: { perView: 3.1, spacing: 16 },
                  disabled: perspectives.length <= 3,
                },
              },
            }}
            slides={perspectives.map((item, index) => ({
              node: (
                <SC._Perspective
                  key={`perspective-desktop-${index}`}
                  variants={variants.perspective}
                  {...item}
                />
              ),
            }))}
            {...sliderProps}
          />
        </motion.div>
      )}
    </SC.Container>
  )
}

const usePerspectivePushMotion = () => {
  const motions = useMemo(
    () => ({
      slider: motionGroup({ staggerChildren: 0.12 }).motionProps,
    }),
    []
  )

  const variants = useMemo(
    () => ({
      perspective: slideReveal({}),
    }),
    []
  )

  return { motions, variants }
}

export default PerspectivePush
